import getFooterConfig from "./appFooter.config";

export function useAppFooter() {
  const url = useRequestURL()
  const config = getFooterConfig(url.protocol + '//' + url.host)

  return {
    config,
  }
}